<div class="container innerContent api-information-cards">
  <div class="row">
    <div class="card-container col-sm-12 col-lg-4 col-md-4" *ngFor="let data of apiInformation">
      <div class="card">
        <div class="image-tile-container">
          <div class="outer-tile">
            <div class="image-tile show-image" style="background-image: url('{{ data.headImage }}');"></div>
          </div>
        </div>
        <h4 class="card-title">
          {{ data.title }}
        </h4>
        <div class="api-information-card-body" [innerHtml]="returnHtmlFromRichText(data.richTextBody) | mdToHtml"></div>
      </div>
    </div>
  </div>
</div>
